import { call, put, takeEvery } from "redux-saga/effects";
import {
    GET_CHARGEBACK_MONITORING_LIST,
    GET_CHARGEBACK_MONITORING_SEARCH,
} from "./actionTypes"

import {
    getChargebackMonitoringListSuccess,
    getChargebackMonitoringSearchSuccess,
    chargebackMonitoringApiError
} from "./actions"

import {
    getChargebackMonitoringList,
    getChargebackMonitoringSearch,
} from "../../helpers/backend_helper/backend_helper"

function* onGetChargebackMonitoringList({ payload: record })  {
    try {
        const response = yield call(getChargebackMonitoringList,record)
        yield put(getChargebackMonitoringListSuccess(response))
    } catch (error) {
        yield put(chargebackMonitoringApiError(error))
    }
}
function* onGetChargebackMonitoringSearch({ payload: record }) {
    try {
        const response = yield call(getChargebackMonitoringSearch, record)
        yield put(getChargebackMonitoringSearchSuccess(response))
    } catch (error) {
        yield put(chargebackMonitoringApiError(error))
    }
}

function* chargebackMonitoringManagementSaga() {
    yield takeEvery(GET_CHARGEBACK_MONITORING_LIST, onGetChargebackMonitoringList)
    yield takeEvery(GET_CHARGEBACK_MONITORING_SEARCH, onGetChargebackMonitoringSearch)
}

export default chargebackMonitoringManagementSaga
